import fetch from 'auth/FetchInterceptor'

const pushService = {}

pushService.all = function () {
  return fetch({
    url: '/notification/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

pushService.paginated = function ({ page = 0, size = 10, nomeCliente = '' } = {}) {
  return fetch({
    url: '/notification',
    method: 'get',
    params: { page, size, nomeCliente },
  })
}

pushService.save = function (data) {
  return fetch({
    url: '/notification',
    method: 'post',
    data: data
  })
}

pushService.getTodasNotificacoes = function ({ page = 0, size = 10 } = {}) {
  return fetch({
    url: '/notificacao',
    method: 'get',
    params: { page, size },
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.getNovas = function () {
  return fetch({
    url: '/notificacao/novas',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.getFull = function (id) {
  return fetch({
    url: `/notificacao/${id}/full`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.confirmar = function (id) {
  return fetch({
    url: `/notificacao/${id}/confirmar`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.confirmarTodas = function () {
  return fetch({
    url: '/notificacao/confirmar/todas',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.getBlacklistAlertaTraccar = function () {
  return fetch({
    url: '/blacklist-alerta-traccar',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

pushService.updateBlacklistAlertaTraccar = function (alertasDesabilitados) {
  return fetch({
    url: '/blacklist-alerta-traccar',
    method: 'put',
    data: { alertasDesabilitados },
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export default pushService